import LegalShell from "@/components/LegalShell";

export default function CookiePolicy() {
  return (
    <LegalShell
      title="Cookie Policy"
      subtitle="How we use cookies on this website."
      testId="cookie-policy-page"
    >
      <p>
        This Cookie Policy explains how Salihi Group (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;) uses cookies and similar
        technologies on <span className="text-navy">www.salihigroup.com</span>. This policy should be read
        together with our <a className="text-gold hover:underline" href="/privacy-policy">Privacy Policy</a>.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">1. What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They allow the site to
        recognise your device and store certain information about your visit.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">2. Categories we use</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li><strong className="text-navy">Strictly necessary cookies</strong> — required for the site to
          function. Cannot be disabled.</li>
        <li><strong className="text-navy">Analytics cookies</strong> — help us understand how visitors use
          the site so we can improve it. Loaded only after you accept.</li>
        <li><strong className="text-navy">Preference cookies</strong> — remember your cookie choices and any
          user preferences.</li>
      </ul>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">3. Managing cookies</h2>
      <p>
        You can accept or decline non-essential cookies via the cookie banner. You can also change your
        preferences at any time by clicking &ldquo;Cookie preferences&rdquo; in the footer or by clearing cookies in your
        browser settings.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">4. Governing law</h2>
      <p>This policy is governed by the laws of the Federal Republic of Somalia.</p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">5. Contact</h2>
      <p>
        For any question about this policy, contact us at{" "}
        <a className="text-gold hover:underline" href="mailto:info@salihigroup.com">info@salihigroup.com</a>.
      </p>
    </LegalShell>
  );
}
